// Shared formatting helpers for the Time and Wage Audit module.

export function fmtNumber(n) {
  return Number(n || 0).toLocaleString('en-US');
}

export function fmtMiles(n) {
  return `${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} mi`;
}

export function fmtPct(n) {
  return n === null || n === undefined ? '—' : `${Number(n).toFixed(0)}%`;
}

export function fmtMph(n) {
  return n === null || n === undefined ? '—' : `${Number(n).toFixed(1)} mph`;
}

export function fmtDate(d) {
  if (!d) return '—';
  const s = String(d).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${+m[2]}/${+m[3]}/${m[1]}`;
  return s;
}

// Both feeds ship worker_name with the id already embedded — "Albert
// Rodriguez (30677)" — and every display wants the two parts styled
// differently. Splitting here rather than at each call site keeps one copy of
// the pattern; there were three before this, and supervisor names carry the
// same shape.
//
// Falls back to employee_id when the name is missing or unparsed, so a row
// never renders as a blank identity.
export function splitWorkerName(workerName, employeeId) {
  const raw = String(workerName ?? '').trim();
  const m = raw.match(/^(.*?)\s*\((\d+)\)\s*$/);
  if (m) return { name: m[1], id: m[2] };
  return { name: raw || String(employeeId ?? ''), id: String(employeeId ?? '') };
}

// gap_start/gap_end are UTC instants — display in Pacific time, since the
// spec is explicit every site is California.
export function fmtTimePT(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleTimeString('en-US', {
    timeZone: 'America/Los_Angeles', hour: 'numeric', minute: '2-digit',
  });
}
